<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Kolekcja Nobilium</h3>
    </app-contentpageheader>
    <app-nobilium />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../../components/common/ContentPageHeader.vue";
import Nobilium from "../../components/collections/types/Nobilium.vue";
import Footer from "../../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../../assets/common/wood.jpg")
    };
  },
  components: {
    "app-nobilium": Nobilium,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
